import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Input.module.css';
export const Input = forwardRef(({ error = false, errorMessage, fullWidth = false, glass = false, className = '', type = 'text', ...props }, ref) => {
    const hasError = typeof error === 'string' ? true : error;
    const errorText = typeof error === 'string' ? error : errorMessage;
    const classes = [
        styles.input,
        hasError && styles.error,
        fullWidth && styles.fullWidth,
        glass && styles.glass,
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx("input", { ref: ref, type: type, className: classes, "aria-invalid": hasError, "aria-describedby": errorText ? 'input-error' : undefined, ...props }), errorText && (_jsx("span", { id: "input-error", className: styles.errorMessage, role: "alert", children: errorText }))] }));
});
Input.displayName = 'Input';
